<template>
  <el-dialog class="app-build-crud"
             :title="((this.appBuild) ? 'Edit' : 'Create') + ' App Build'"
             @close="close"
             v-loading="loading"
             :element-loading-text="'Saving App Build...'"
             :visible.sync="isVisible"
             :width="(isDialogFullscreen) ? '' : '480px'"
             :fullscreen="isDialogFullscreen"
             :before-close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="180px" class="app-build-form">
      <el-form-item label="Project" prop="project_id">
        <el-select v-model="form.project_id" filterable clearable placeholder="Type to filter">
          <el-option-group
            v-for="group in projectOptions"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="App Name" prop="app_name">
        <el-input v-model="form.app_name" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Version Number" prop="version_num" ref="version_num">
        <el-input v-model="form.version_num" auto-complete="off" placeholder="1.0.0" />
      </el-form-item>
      <el-form-item  label="App Icon (512x512)" prop="icon_512_path">
        <el-upload
          class="icon-uploader"
          :class="{uploaded: imagePreviewUrl}"
          v-loading="iconLoading"
          :action="AppBuildIconURL"
          :headers="uploadFormHeaders"
          drag
          :show-file-list="false"
          :on-success="handleIconSuccess"
          :before-upload="beforeIconUpload">
          <img v-if="imagePreviewUrl" :src="imagePreviewUrl" class="icon">
          <i v-else class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="Platforms" prop="platforms">
        <el-checkbox-group v-model="form.platforms">
          <el-checkbox-button label="ios">iOS</el-checkbox-button>
          <el-checkbox-button label="android">Android</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <transition v-if="isIOSEnabled">
        <el-form-item label="iOS Bundle ID" prop="ios_bundle_id">
          <el-input v-model="form.ios_bundle_id" auto-complete="off" placeholder="co.mirk.ih.PROJECTID" />
        </el-form-item>
      </transition>
      <transition v-if="isIOSEnabled">
      <el-form-item label="Enable Auto Update?" prop="should_update">
        <el-switch v-model="form.should_update" />
      </el-form-item>
      </transition>
      <transition v-if="isIOSEnabled">
        <el-form-item label="iOS IPA File" prop="ios_ipa_path">
          <el-upload
            v-loading="ipaLoading"
            class="icon-uploader"
            :class="{uploaded: ipaUploaded}"
            :action="AppBuildIpaURL"
            :headers="uploadFormHeaders"
            drag
            :show-file-list="false"
            :on-success="handleIpaSuccess"
            :on-error="handleIpaError"
            :before-upload="beforeIpaUpload">
            <icon v-if="ipaUploaded" name="brands/apple" class="apple-icon" />
            <i v-else class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </transition>

      <transition v-if="isAndroidEnabled">
      <el-form-item label="Android APK File" prop="android_apk_path">
        <el-upload
          v-loading="apkLoading"
          class="icon-uploader"
          :class="{uploaded: apkUploaded}"
          :action="AppBuildApkURL"
          :headers="uploadFormHeaders"
          drag
          :show-file-list="false"
          :on-success="handleApkSuccess"
          :on-error="handleApkError"
          :before-upload="beforeApkUpload">
          <icon v-if="apkUploaded" name="brands/android" class="apple-icon" />
          <i v-else class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      </transition>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">Cancel</el-button>
      <el-button type="primary" @click="submit">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {AppBuildIconURL, AppBuildIpaURL, AppBuildApkURL} from '../../util/api'
  export default {
    name: 'app-build-crud',
    props: {
      appBuild: null
    },
    data () {
      return {
        isVisible: true,
        loading: false,
        windowWidth: 0,

        isNewAppBuild: true,
        AppBuildIconURL: AppBuildIconURL,
        AppBuildIpaURL: AppBuildIpaURL,
        AppBuildApkURL: AppBuildApkURL,
        uploadFormHeaders: {
          'Authorization': 'Bearer ' + this.$store.state.accessToken
        },
        iconLoading: false,
        ipaLoading: false,
        apkLoading: false,
        imagePreviewUrl: false,
        ipaUploaded: false,
        apkUploaded: false,
        form: {
          platforms: [],
          app_name: '',
          project_id: null,
          version_num: '',
          ios_bundle_id: '',
          icon_512_path: null,
          icon_57_path: null,
          android_apk_path: null,
          ios_ipa_path: null,
          should_update: null
        },

        rules: {
          project_id: [
            {required: true, message: 'Project is required', trigger: 'blur'}
          ],
          app_name: [
            {required: true, message: 'App Name is required', trigger: 'blur'}
          ],
          ios_bundle_id: [
            {required: true, message: 'iOS Bundle ID is required', trigger: 'blur'}
          ],
          icon_512_path: [
            {required: true, message: 'App Icon is required', trigger: 'blur'}
          ],
          ios_ipa_path: [
            {required: true, message: 'iOS IPA File is required', trigger: 'blur'}
          ],
          android_apk_path: [
            {required: true, message: 'Android APK File is required', trigger: 'blur'}
          ],
          version_num: [
            {required: true, message: 'Version Number is required', trigger: 'blur'}
          ],
          platforms: [
            {required: true, message: 'App Platforms is required', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      setAppBuildDetails () {
        if (this.appBuild) {
          this.form.app_name = this.appBuild.name
          this.form.project_id = this.appBuild.project_id
          this.form.version_num = this.appBuild.version_num
          this.form.icon_512_path = this.appBuild.icon_512_path
          this.form.icon_57_path = this.appBuild.icon_57_path
          this.imagePreviewUrl = this.appBuild.icon_512_url
          this.form.ios_bundle_id = this.appBuild.ios_bundle_id

          this.form.ios_ipa_path = this.appBuild.ios_ipa_path
          this.form.android_apk_path = this.appBuild.android_apk_path
          this.form.should_update = this.appBuild.should_update

          if (this.form.ios_ipa_path !== null) {
            this.form.platforms.push('ios')
            this.ipaUploaded = true
          }
          if (this.form.android_apk_path !== null) {
            this.form.platforms.push('android')
            this.apkUploaded = true
          }
        }
      },
      close () {
        this.$emit('close')
      },
      submit () {
        // Trim inputs
        this.form.app_name = this.form.app_name.trim()
        this.form.ios_bundle_id = this.form.ios_bundle_id.trim()
        this.form.version_num = this.form.version_num.trim()
        if (this.appBuild === null && !this.isVersionNumberFree()) {
          this.$refs['version_num'].error = 'v' + this.form.version_num + ' is already in use by this App.'
          return false
        }
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // Check that the version number is unique
            if (this.appBuild === null && !this.isVersionNumberFree()) {
              this.$message.error('Version ' + this.form.version_num + ' is already taken for this App.')
              return false
            } else {
              var object = {
                id: (this.appBuild) ? this.appBuild.id : null,
                name: this.form.app_name.trim(),
                project_id: this.form.project_id,
                version_num: this.form.version_num.trim(),
                icon_512_path: this.form.icon_512_path,
                icon_57_path: this.form.icon_57_path,
                should_update: this.form.should_update,
              }

              if (this.isIOSEnabled) {
                object = {
                  ...object,
                  ios_bundle_id: this.form.ios_bundle_id.trim(),
                  ios_ipa_path: this.form.ios_ipa_path
                }
              }

              if (this.isAndroidEnabled) {
                object = {
                  ...object,
                  android_apk_path: this.form.android_apk_path
                }
              }

              if (this.appBuild) {
                // A task was passed, update it
                this.$store.dispatch('updateAppBuild', object)
              } else {
                // A task was not past, create a new one
                this.$store.dispatch('createAppBuild', object)
              }
              return true
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.handleClose(() => {
          this.isVisible = false
        })
      },
      handleClose (done) {
        if (this.isFormDirty) {
          this.$confirm('Are you sure to cancel?')
          .then(() => { done() })
          .catch(() => {})
        } else {
          done()
        }
      },
      resetForm () {
        this.$refs['form'].resetFields()
        window.history.back()
      },
      handleIconSuccess (res, file) {
        this.form.icon_512_path = file.response.large
        this.form.icon_57_path = file.response.small
        this.imagePreviewUrl = file.response.preview
        this.iconLoading = false
      },
      beforeIconUpload (file) {
        const isPNG = (file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPNG) {
          this.$message.error('Icon must be PNG format!')
        }
        if (!isLt2M) {
          this.$message.error('Icon size can not exceed 2MB!')
        }
        if (isPNG && isLt2M) {
          this.iconLoading = true
          return true
        }

        return false
      },

      handleIpaSuccess (res, file) {
        this.ipaLoading = false
        this.ipaUploaded = true
        this.form.ios_ipa_path = file.response.ios_ipa_path
      },

      handleIpaError () {
        this.$message.error('Error uploading IPA File!')
        this.ipaLoading = false
        this.ipaUploaded = false
        this.form.ios_ipa_path = null
      },

      beforeIpaUpload (file) {
        if (file.name.toLowerCase().substring(file.name.length - 4) === '.ipa') {
          this.ipaLoading = true
          this.ipaUploaded = false
          return true
        } else {
          this.$message.error('Invalid iOS IPA file (does not end in .ipa)')
          return false
        }
      },

      handleApkSuccess (res, file) {
        this.apkLoading = false
        this.apkUploaded = true
        this.form.android_apk_path = file.response.android_apk_path
      },

      handleApkError () {
        this.$message.error('Error uploading APK File!')
        this.apkLoading = false
        this.apkUploaded = false
        this.form.android_apk_path = null
      },

      beforeApkUpload (file) {
        if (file.name.toLowerCase().substring(file.name.length - 4) === '.apk') {
          this.apkLoading = true
          this.apkUploaded = false
          return true
        } else {
          this.$message.error('Invalid Android APK file (does not end in .apk)')
          return false
        }
      },

      handleRouteParamUserId () {
        this.isNewAppBuild = this.routeParamUserId === 'new'

        if (!this.isNewAppBuild) {
          this.$store.dispatch('getAppBuild', this.routeParamUserId)
        }
      },

      // When the user selects a project, look for previous app builds for the same project and attempt to use the same icon images
      tryGetLastAppDetails () {
        // Default values to be changed
        let app_name = ''
        let platforms = []
        let icon_512_path = null
        let icon_57_path = null
        let imagePreviewUrl = null
        let ios_bundle_id = ''

        if (this.form.project_id) {
          for (let k in this.appBuilds) {
            if (this.appBuilds.hasOwnProperty(k)) {
              let build = this.appBuilds[k]
              if (build.project_id === this.form.project_id) {

                if (!this.form.app_name) { // Dont overwrite if already set
                  app_name = build.name
                }

                // Try to get last image
                if (!this.imagePreviewUrl) { // Dont overwrite if user has already added an image
                  // Note, we keep running so we get the latest build - easier than sorting DESC by date/ID
                  icon_512_path = build.icon_512_path
                  icon_57_path = build.icon_57_path
                  imagePreviewUrl = build.icon_512_url
                }

                // Add iOS Details if they exist
                if (build.ios_bundle_id && this.form.platforms.indexOf('ios') === -1) {
                  platforms.push('ios')
                }

                if (!this.form.ios_bundle_id) {
                  ios_bundle_id = build.ios_bundle_id
                }

                // Preselect Android if the last build was an Android build
                if (build.android_apk_path && this.form.platforms.indexOf('android') === -1) {
                  platforms.push('android')
                }
              }
            }
          }

          if (ios_bundle_id === '') {
            // Could not match a bundle ID. Try to generate one instead
            ios_bundle_id = 'co.mirk.ih.' + this.projects[this.form.project_id].project_code.toUpperCase()
          }
        }

        this.form.app_name = app_name
        this.form.platforms = platforms
        this.form.icon_512_path = icon_512_path
        this.form.icon_57_path = icon_57_path
        this.form.ios_bundle_id = ios_bundle_id
        this.imagePreviewUrl = imagePreviewUrl
      },
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      },
      isVersionNumberFree () {
        // Has the Version Number for the supplied Bundle ID been taken?
        for (let k in this.appBuilds) {
          if (this.appBuilds.hasOwnProperty(k)) {
            let build = this.appBuilds[k]
            if (build.ios_bundle_id === this.form.ios_bundle_id &&
              build.version_num.trim() === this.form.version_num.trim()) {
              return false
            }
          }
        }
        return true
      }
    },
    computed: {
      isDialogFullscreen () {
        return this.windowWidth < 520
      },
      isFormDirty () {
        return this.form.project_id !== null ||
          this.form.version_num !== '' ||
          this.form.ios_bundle_id !== '' ||
          this.form.icon_512_path !== null ||
          this.form.icon_57_path !== null ||
          this.form.ios_ipa_path !== null ||
          this.form.should_update !== null ||
          this.form.ipaLoading !== false ||
          this.form.apkLoading !== false ||
          this.form.iconLoading !== false
      },
      projectOptions () {
        // Group Projects by their Client
        let optionsObj = {}
        Object.keys(this.projects)
        .map((k) => this.projects[k])
        .sort((a, b) => {
          return a.client_name > b.client_name ? 1 : -1
        })
        .map((project) => {
          if (!optionsObj.hasOwnProperty(project.client_name)) {
            optionsObj[project.client_name] = []
          }
          optionsObj[project.client_name].push({
            label: project.project_code + ' - ' + project.name,
            value: project.id
          })
        })

        let options = []

        for (let clientName in optionsObj) {
          options.push({
            label: clientName,
            options: optionsObj[clientName].sort((a, b) => {
              return a.label > b.label ? 1 : -1
            })
          })
        }
        return options
      },
      isIOSEnabled () {
        return this.form.platforms.indexOf('ios') > -1
      },
      isAndroidEnabled () {
        return this.form.platforms.indexOf('android') > -1
      },
      projects () {
        return this.$store.state.projects.objects
      },
      appBuilds () {
        return this.$store.state.appBuilds.objects
      },
      saving () {
        return this.$store.state.appBuilds.createInProgress || this.$store.state.appBuilds.updateInProgress
      },
      affectedAppBuild () {
        if (this.appBuild) {
          return this.$store.state.appBuilds.updatedObject
        } else {
          return this.$store.state.appBuilds.createdObject
        }
      }
    },
    created () {
      // this.setTaskDetails()
    },
    mounted () {
      // We need all Users and Projects for the dropdowns.. make sure we have everything
      this.setAppBuildDetails()
      this.$store.dispatch('getProjects')
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    },
    watch: {
      'form.project_id' () {
        if (!this.appBuild) {
          this.tryGetLastAppDetails()
        }
      },
      'saving' () {
        // If the Project store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.saving) {
          this.loading = true
        } else {
          this.loading = false
          if (!this.affectedAppBuild) {
            // There was an error creating/updaing the project.
            // @TODO: Implement error handling
            console.error('Create/Update Failed. @TODO: Add error handling')
          } else {
            this.$message({
              message: (this.task) ? 'App Build updated!' : 'App Build created!',
              type: 'success'
            })
            this.isVisible = false
            this.$emit('close', this.affectedAppBuild)
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .app-build-crud {
    .el-select {
      width: 100%;
    }
    .apple-icon {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: auto;
      transform: translateY(-50%);
      color: #67c23a !important;
    }
  }
</style>
